import React from "react";
import { Link } from "react-router-dom";

import { projectsData } from "./data-projets";

import "./style.scss";

const Home = () => {
  const width = 300;
  const height = 200;
  return (
    <div>
      <h1 className="presentation">
        <span className="desktop-only">
          Installée à Ivry-sur-Seine, je suis designer graphique dans les
          secteurs culturel et social. Je conçois des identités visuelles,
          systèmes graphiques et animations pour des projets engagés. Mon
          objectif est de renforcer le lien entre institutions et citoyens par
          un design ancré dans le réel et participatif.
        </span>
        <span className="mobile-only">
          Installée à Ivry-sur-Seine, je suis designer graphique dans les
          secteurs culturel et social et je croise les disciplines pour
          développer une approche visuelle engagée et pertinente.
        </span>
      </h1>
      <div className="home">
        {projectsData.map(({ category, projects }) => (
          <section key={category} className="category-section">
            <h6 className="btn-category btn-gap">{category}</h6>
            <ul className="project-list">
              {projects.map(({ id, title, date, imageUrl, link }) => (
                <li key={id} className="project-item">
                  <div className="project-info">
                    <Link to={link} className="project-title">
                      {title}
                    </Link>
                    <p className="project-date">{date}</p>
                  </div>
                  <div
                    className="project-image"
                    style={{ aspectRatio: `${width} / ${height}` }}
                  >
                    <Link to={link}>
                      <img
                        src={imageUrl}
                        alt={title}
                        width={width}
                        height={height}
                        loading="lazy"
                      />
                    </Link>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Home;
